module.exports = {
    app_title: "Admin Dashboard",
    tokenKey: "tntpkcc_jwt",
    lang_id: "en",
    cipher_crypt: "09xuaqpik",
    prefixes: {
        merchant: "_q5mct_",
        user: "_q5usr_",
        category: "_q5ctgr_"
    }
};